module.exports = __webpack_public_path__ + "static/img/IMG_20170525_103134.7fe9fb5c.jpg";